/**
 * Shared dark-theme confirm dialog for EGMs admin pages
 * (Manufacturers Management, Game Names Management).
 *
 * Pair with cssClass ADMIN_CONFIRM_ALERT_CLASS
 * (styles in _m-admin-confirm-alert.scss).
 */

export const ADMIN_CONFIRM_ALERT_CLASS = 'admin-confirm-alert';

export type AdminConfirmAlertButtonHandler = () => boolean | void | Promise<boolean | void>;

export type PresentAdminConfirmAlertOpts = {
  header: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: AdminConfirmAlertButtonHandler;
};

/**
 * Options for Ionic useIonAlert() / AlertController.present() with
 * readable Cancel (light) + Confirm (gold accent) on the dark dialog.
 */
export function buildAdminConfirmAlertOptions(opts: PresentAdminConfirmAlertOpts) {
  return {
    cssClass: ADMIN_CONFIRM_ALERT_CLASS,
    header: opts.header,
    message: opts.message,
    buttons: [
      {
        text: opts.cancelText || 'Cancel',
        role: 'cancel' as const,
        cssClass: 'admin-confirm-alert__cancel',
      },
      {
        text: opts.confirmText || 'Update',
        cssClass: 'admin-confirm-alert__confirm',
        handler: opts.onConfirm,
      },
    ],
  };
}
